import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import type { PublicProduct } from './usePublicProduct';

export function usePublicProductById(productId: string | undefined) {
  const [product, setProduct] = useState<PublicProduct | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!productId) {
      setProduct(null);
      setLoading(false);
      return;
    }

    let cancelled = false;

    async function fetchProduct() {
      setLoading(true);
      setError(null);

      try {
        const PUBLIC_STATUSES = ['public', 'sold_out', 'upcoming'];

        const { data, error: queryError } = await supabase
          .from('producer_products')
          .select('*')
          .eq('id', productId)
          .in('status', PUBLIC_STATUSES)
          .is('deleted_at', null)
          .maybeSingle();

        if (cancelled) return;

        if (queryError) {
          setError('Kunde inte hämta produkt.');
          setProduct(null);
          setLoading(false);
          return;
        }

        setProduct((data as PublicProduct | null) ?? null);
        setLoading(false);
      } catch {
        if (cancelled) return;
        setError('Kunde inte hämta produkt.');
        setProduct(null);
        setLoading(false);
      }
    }

    fetchProduct();
    return () => {
      cancelled = true;
    };
  }, [productId]);

  return { product, loading, error };
}
